import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { DeviceType, PanelType } from '../../models/enums/device-type.enum';
import { AbstractButton, BottomButtonsComponent } from '../bottom-buttons/bottom-buttons.component';
import { DeviceTypeLabelComponent } from '../device-type-label/device-type-label.component';

export type SuccessTemplateContent = {
    text?: string;
    serial?: string;
    surname?: string;
    type: DeviceType;
    buttons?: AbstractButton[];
};

@Component({
    selector: 'web-success-template',
    templateUrl: './success-template.component.html',
    styleUrls: ['./success-template.component.scss'],
    imports: [BottomButtonsComponent, DeviceTypeLabelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessTemplateComponent {
    content: InputSignal<SuccessTemplateContent> = input<SuccessTemplateContent>({
        type: PanelType.CITY,
    });
}
